"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkFromProperty = exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const Types_1 = require("Types");
const Link = ({ href, children, onClick, target }) => {
    const checkIfExternal = /^(http|https):/;
    return href ? (react_1.default.createElement("a", { target: !target ? (checkIfExternal.test(href) ? Types_1.Target.BLANK : Types_1.Target.SELF) : target, href: href, rel: 'noopener noreferrer', onClick: onClick, style: { textDecoration: 'none' } }, children)) : (react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.Link = Link;
const LinkFromProperty = link => {
    return (react_1.default.createElement(exports.Link, { href: link.href, target: link.target }, link.text));
};
exports.LinkFromProperty = LinkFromProperty;
exports.default = exports.Link;
